import { useEffect } from "react"
import useIllustrationLogs from "../hooks/useIllustrationLogs"
import Loader from "./Loader"

const IllustrationLogModal = ({
  onClose,
  accessionNo,
  logType,
  inboundMessageId,
}) => {
  const { data, isLoading } = useIllustrationLogs({
    accessionNo,
    logType,
    inboundMessageId,
  })

  useEffect(() => {
    document.body.style.overflow = "hidden"
    return () => {
      document.body.style.overflow = "unset"
    }
  }, [])

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg max-w-7xl w-full overflow-hidden">
        <div className="p-4 flex justify-between items-center">
          {data && (
            <div className="flex gap-8">
              <p>
                <strong>Accession No: </strong> {data.AccessionNo}
              </p>
              <p>
                <strong>Message Id: </strong> {data.MessageId}
              </p>
              <p>
                <strong>View Type: </strong> {data.LogType}
              </p>
            </div>
          )}
          <button
            className="text-gray-600 hover:text-gray-900 text-3xl ml-auto"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <div className="max-h-96 overflow-y-auto p-4">
          {isLoading ? (
            <div className="py-2">
              <Loader />
            </div>
          ) : (
            <ModalBody data={data} />
          )}
        </div>
      </div>
    </div>
  )
}

const ModalBody = ({ data }) =>
  data ? (
    <div className="grid grid-cols-1 gap-3">
      <div>
        <h2 className="text-xl font-bold mb-1">AI Prompt</h2>
        <p className="text-gray-900">{data.AIPrompt}</p>
      </div>
      <div>
        <h2 className="text-xl font-bold mb-1">AI Response</h2>
        <p className="text-gray-900">
          <div
            dangerouslySetInnerHTML={{
              __html: data.AIResponse.replaceAll("\n", "<br/>").replaceAll(
                "\t",
                "&nbsp;&nbsp;&nbsp;&nbsp;"
              ),
            }}
          />
        </p>
        <div>
          <h2 className="text-xl font-bold mb-1">Report text</h2>
          <p className="text-gray-900">{data.ExtractedReportText}</p>
        </div>
      </div>
      {data.IsError && (
        <div>
          <h2 className="text-xl font-bold">Error</h2>
          <p className="text-sm text-gray-p00">{data.ErrorDesc}</p>
        </div>
      )}
    </div>
  ) : (
    <div className="flex flex-col items-center justify-center">
      <h2 className="text-xl font-bold mb-1">No logs found</h2>
      <p className="text-gray-900">No logs found for this illustration.</p>
    </div>
  )

export default IllustrationLogModal
